var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 2.433L14.433 12 24 21.567 21.567 24 12 14.433 2.433 24 0 21.567 9.567 12 0 2.433 2.433 0 12 9.567 21.567 0z","fill":"currentColor","fillRule":"evenodd"}));
}

Cross.defaultProps = {"viewBox":"0 0 24 24","width":"24","height":"24"};

module.exports = Cross;

Cross.default = Cross;
